const options = {
  5: "bg-green-50/5",
  10: "bg-green-50/10",
  25: "bg-green-50/25",
  50: "bg-green-50/50",
  75: "bg-green-50/75",
  90: "bg-green-50/90",
  100: "bg-green-50",
};

const from = {
  5: "from-green-50/5",
  10: "from-green-50/10",
  25: "from-green-50/25",
  50: "from-green-50/50",
  75: "from-green-50/75",
  90: "from-green-50/90",
  100: "from-green-50",
};

export default function getBackgroundGreen50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
